import { Box, Typography, styled } from "@mui/material";
import { colors } from "../../../theme/colors";

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
});

export const ModalTitle = styled(Typography)({
  fontSize: "26px",
  fontWeight: 600,
  color: colors.text.primary,
  textAlign: "center",
  marginBottom: "12px",
});

export const ModalText = styled(Typography)({
  color: colors.text.secondary,
  textAlign: "center",
  fontFamily: "Sora",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "32px",
  marginBottom: "60px",
});

export const ButtonsContainer = styled(Box)({
  display: "flex",
  gap: "24px",
  justifyContent: "center",
  width: "100%",
});


